import { PRODUCT_SLUGS_IT_TO_EN } from '@/data/productPages';

export const SLUGS_IT_TO_EN = {
  '/': '/',
  '/chi-siamo': '/about',
  '/chi-siamo/missione': '/about/mission',
  '/soluzioni': '/solutions',
  '/guide': '/guides',
  '/cassa-malati': '/solutions/health',
  '/cassa-malati/calcolatore-premi': '/health-insurance-premium-calculator',
  '/cassa-malati/cassa-malati-obbligatoria': '/solutions/health/mandatory-health-insurance',
  '/cassa-malati/cassa-malati-facoltativa': '/solutions/health/supplementary-health-insurance',
  '/guide/salute/cambio-cassa-malati-premi-disdetta': '/guides/health/switching-health-insurance-premiums-cancellation',
  '/guide/salute/assicurazione-prenatale': '/guides/health/prenatal-insurance',
  '/soluzioni/privati': '/solutions/individuals',
  '/guide/privati/mettersi-in-proprio': '/guides/individuals/going-self-employed',
  '/guide/privati/andare-a-vivere-da-soli': '/guides/individuals/living-on-your-own',
  '/guide/privati/comprare-casa-a-30-anni': '/guides/individuals/buying-a-home-at-30',
  '/guide/privati/importare-auto-in-svizzera': '/guides/individuals/importing-a-car-to-switzerland',
  '/guide/privati/trasferirsi-in-svizzera': '/guides/individuals/moving-to-switzerland',
  '/soluzioni/aziende': '/solutions/businesses',
  '/guide/aziende/aprire-un-azienda': '/guides/businesses/starting-a-business',
  '/guide/aziende/forme-giuridiche-svizzera': '/guides/businesses/legal-forms-switzerland',
  '/soluzioni/aziende/tipologie-assicurazioni': '/solutions/businesses/business-insurance-types',
  '/soluzioni/previdenza': '/solutions/pension',
  '/centro-sinistri': '/claims-centre',
  '/contatti': '/contact',
  '/prenota': '/book',
  '/consiglio-a-terzi': '/refer-someone',
  '/consiglio-a-terzi/commissioni': '/refer-someone/rewards',
  '/consiglio-a-terzi/condizioni': '/refer-someone/conditions',
  '/calcola-risparmio-fiscale': '/tax-savings-calculator',
  '/privacy': '/privacy',
  '/cookie-policy': '/cookie-policy',
  '/note-legali': '/legal-notice',
  '/404': '/404',
  ...PRODUCT_SLUGS_IT_TO_EN,
};

export const SLUGS_EN_TO_IT = Object.fromEntries(
  Object.entries(SLUGS_IT_TO_EN).map(([it, en]) => [en, it])
);

export const toEnPath = (itPath) => SLUGS_IT_TO_EN[itPath] || itPath;
export const toItPath = (enPath) => SLUGS_EN_TO_IT[enPath] || enPath;
